export const tabs = {
  tabs: {
    colorScheme: {
      light: {
        tablist: {
          borderColor: '{slate.200}',
        },
      },
    },
    tab: {
      padding: '.9rem 2rem',
      borderWidth: '0 0 2px 0',
      borderColor: '{slate.200}',
      margin: '0 0 -2px 0',
      hoverColor: 'var(--p-text-color-secondary)',
      hoverBorderColor: 'var(--p-text-color-secondary)',
    },
    tablist: {
      borderWidth: '0 0 2px 0',
    },
  },
};
